import { inject, Injectable } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PercentFormatter } from '../../../shared/helpers/percent-formatter.helper';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

@Injectable()
export class CEtrTradeProvider {
  cEtrRSATradeForm: FormGroup;
  cEtrTradeForm: FormGroup;
  readonly #fb = inject(FormBuilder);

  initTradeForm(data?: any, isEdit?: boolean): void {
    const today = new Date();
    const nextYear = new Date(today);
    nextYear.setFullYear(today.getFullYear() + 1);

    this.cEtrTradeForm = this.#fb.group({
      type: [data?.type || ''],
      creditorId: [
        { value: data?.creditorId || null, disabled: isEdit },
        [Validators.required],
      ],
      edso: [data?.edso || '', [Validators.required, Validators.max(3650)]],
      ccy: [data?.ccy || '', [Validators.required]],
      faceValue: [
        data?.faceValue || '',
        [
          ...(isEdit ? [] : [Validators.max(data?.faceValue)]),
          Validators.required,
        ],
      ],
      invoiceDate: [data?.invoiceDate || null, [Validators.required]],
      expectedDate: [data?.expectedDate || null, [Validators.required]],
      deposit: [
        data?.deposit || data?.deposit === 0
          ? PercentFormatter(+data?.deposit * 100, false)
          : null,
        [Validators.min(0), Validators.max(100), Validators.required],
      ],
      rejectedMessage: [data?.rejectedMessage || ''],
      rsaTradeId: [data?.rsaTradeId || data?.tradeId || ''],
    });
  }

  initRSAForm(data?: any): void {
    const today = new Date();
    const nextYear = new Date(today);
    nextYear.setFullYear(today.getFullYear() + 1);

    this.cEtrRSATradeForm = this.#fb.group({
      type: [data?.type || ''],
      edso: [data?.edso || '', [Validators.required, Validators.max(3650)]],
      ccy: [data?.ccy || '', [Validators.required]],
      faceValue: [data?.faceValue || '', [Validators.required]],
      noOfEtr: [
        data?.noOfEtr || '',
        [Validators.required, Validators.max(1200)],
      ],
      months: [data?.months || '', [Validators.required, Validators.max(120)]],
      description: [data?.description || ''],
      rejectedMessage: [data?.rejectedMessage || ''],
      creditorId: [
        { value: data?.creditorId || null, disabled: !!data?.acquisitionId },
        [Validators.required],
      ],
    });
  }

  #toNgbDate(dateString: string): NgbDateStruct | null {
    if (!dateString) return null;
    const [y, m, d] = dateString.split('-').map(Number);
    return { year: y, month: m, day: d };
  }
}
